import { useCallback } from 'react';
import { RouterBridge } from './router-bridge';
/**
 * This hook is used to programmatically navigate between pages. Similar to react router's v6 useNavigate.
 * It is still work in progress and might be extended if other features of the react router's useNavigate are needed.
 */
export var useNavigate = function () {
    return useCallback(function (pathname, options) {
        if (options === null || options === void 0 ? void 0 : options.replace) {
            RouterBridge.replace(pathname);
            return;
        }
        RouterBridge.push(pathname);
    }, []);
};
